import {
  DAY_IN_MS,
  HOUR_IN_MS,
  MINUTE_IN_MS,
  MONTH_IN_MS,
  WEEK_IN_MS,
} from "@tradingApp/constants";
import type { ResolutionString } from "../../../../../../public/charting_library";

export function tradingAssetChartTimeframeToInterval(
  timeframe: ResolutionString,
  inMilliseconds = false,
): {
  from: number;
  to: number;
} {
  let to = Date.now();
  let from: number;

  switch (timeframe) {
    case "1":
      from = to - MINUTE_IN_MS;
      break;
    case "5":
      from = to - MINUTE_IN_MS * 5;
      break;
    case "15":
      from = to - MINUTE_IN_MS * 15;
      break;
    case "60":
      from = to - HOUR_IN_MS;
      break;
    case "240":
      from = to - MINUTE_IN_MS * 240;
      break;
    case "1D":
      from = to - DAY_IN_MS;
      break;
    case "3D":
      from = to - DAY_IN_MS * 3;
      break;
    case "1W":
      from = to - WEEK_IN_MS;
      break;
    case "1M":
      from = to - MONTH_IN_MS;
      break;
    default:
      from = to - MINUTE_IN_MS;
  }

  if (inMilliseconds) {
    return { from, to };
  }

  from = Math.floor(from / 1000);
  to = Math.floor(to / 1000);

  return { from, to };
}
